// this is utlity function to get random id
const randomId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export default randomId;
